module.exports = __webpack_public_path__ + "img/NIKKO-IMG-02.0dd55829.jpg";